/**
 * Educator printables (PDF + preview + section copy).
 *
 * Previews live in /images/marketing/educators/printables/.
 * PDFs stay on the assets CDN. Keep every campaign here — do not replace
 * one printable by renaming its folder or file.
 *
 * To feature a different printable on /educators, change
 * `FEATURED_EDUCATOR_PRINTABLE_ID`.
 */

export type EducatorPrintable = {
  pdfUrl: string;
  previewSrc: string;
  heading: string;
  body: string;
  previewAlt: string;
};

export const EDUCATOR_PRINTABLES = {
  summerSlideFlyer: {
    pdfUrl: "https://assets.playmath.org/resources/we-are-teachers-summer-math-slide-flyer.pdf",
    previewSrc:
      "/images/marketing/educators/printables/we-are-teachers-summer-math-slide-flyer-preview.webp",
    heading: "Fight Summer Slide",
    body: "Share with families this summer. QR codes link to free PlayMath games that keep math skills strong while school is out.",
    previewAlt: "Preview of the Fight Summer Slide with PlayMath.org printable flyer",
  },
  choiceBoard: {
    pdfUrl:
      "https://assets.playmath.org/resources/playmathorg-weareteachers-choiceboard-2026-9.pdf",
    previewSrc: "/images/marketing/educators/printables/we-are-teachers-choice-board-preview.webp",
    heading: "Print. Pick. Play.",
    body: "Download these free choice boards by We Are Teachers, featuring PlayMath.org games and activities for independent math time.",
    previewAlt: "Preview of the PlayMath.org We Are Teachers choice board printable",
  },
} as const satisfies Record<string, EducatorPrintable>;

export type EducatorPrintableId = keyof typeof EDUCATOR_PRINTABLES;

/** Which printable the Educators page section shows. */
export const FEATURED_EDUCATOR_PRINTABLE_ID: EducatorPrintableId = "choiceBoard";

export const FEATURED_EDUCATOR_PRINTABLE = EDUCATOR_PRINTABLES[FEATURED_EDUCATOR_PRINTABLE_ID];

/** Show the Educator-page PDF download section. */
export const EDUCATOR_PDF_SECTION_ENABLED = true;
